// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnterpriseCoordinatorAccountServiceModelsVoicemailOptInModel {
    static getAttributeTypeMap() {
        return EnterpriseCoordinatorAccountServiceModelsVoicemailOptInModel.attributeTypeMap;
    }
}
EnterpriseCoordinatorAccountServiceModelsVoicemailOptInModel.discriminator = undefined;
EnterpriseCoordinatorAccountServiceModelsVoicemailOptInModel.attributeTypeMap = [
    {
        "name": "phoneNumberId",
        "baseName": "phoneNumberId",
        "type": "number"
    },
    {
        "name": "isVmOptedIn",
        "baseName": "isVmOptedIn",
        "type": "boolean"
    }
];
//# sourceMappingURL=enterpriseCoordinatorAccountServiceModelsVoicemailOptInModel.js.map